module.exports = __webpack_public_path__ + "images/double-tick-iconef6dbe72b5a28f9cb07ec44a52fa4923.svg";